import {FULL_NAME_PART_MAX_LENGTH} from "../constants/reservation_constants";
import {RESERVATION_NAME_REQUIRED_TEXT, RESERVATION_NAME_TOO_LONG_TEXT} from "../constants/reservation_copy";

// The CRM takes the first word of the profile name as the first name and the second word as the last name - any further words are dropped.
// The last name stays empty for a one-word name - the CRM takes a reservation without it.
const splitFullName = (name: string | null | undefined) => {
    const [firstName = "", lastName = ""] = (name ?? "").trim().split(/\s+/);

    return {firstName, lastName};
};

// null for a name the CRM accepts: a first name and an optional last name, each within the CRM limit
export const getReservationNameError = (name: string | null | undefined): string | null => {
    const {firstName, lastName} = splitFullName(name);

    if (firstName === "") {
        return RESERVATION_NAME_REQUIRED_TEXT;
    }

    if (firstName.length > FULL_NAME_PART_MAX_LENGTH || lastName.length > FULL_NAME_PART_MAX_LENGTH) {
        return RESERVATION_NAME_TOO_LONG_TEXT;
    }

    return null;
};
import {FULL_NAME_PART_MAX_LENGTH} from "../constants/reservation_constants";
import {RESERVATION_NAME_REQUIRED_TEXT, RESERVATION_NAME_TOO_LONG_TEXT} from "../constants/reservation_copy";

// The CRM takes the first word of the profile name as the first name and the second word as the last name - any further words are dropped.
// The last name stays empty for a one-word name - the CRM takes a reservation without it.
const splitFullName = (name: string | null | undefined) => {
    const [firstName = "", lastName = ""] = (name ?? "").trim().split(/\s+/);

    return {firstName, lastName};
};

// null for a name the CRM accepts: a first name and an optional last name, each within the CRM limit
export const getReservationNameError = (name: string | null | undefined): string | null => {
    const {firstName, lastName} = splitFullName(name);

    if (firstName === "") {
        return RESERVATION_NAME_REQUIRED_TEXT;
    }

    if (firstName.length > FULL_NAME_PART_MAX_LENGTH || lastName.length > FULL_NAME_PART_MAX_LENGTH) {
        return RESERVATION_NAME_TOO_LONG_TEXT;
    }

    return null;
};
